module.exports = __webpack_public_path__ + "static/img/male-2.a841c4ca.png";